<mat-sidenav-container fullscreen>
  <mat-sidenav
    #sidenav
    mode="side"
    class="example-sidenav"
    [ngStyle]="{ 'width.em': sidenavWidth }"
    [opened]="_authService.isOpen$ | async">
    <mega-store-vendor-sidebar></mega-store-vendor-sidebar>
  </mat-sidenav>
  <div class="example-sidenav-content">
    <div class="top_header">
      <div class="toggle" (click)="toggleSidenav()">
        <span></span>
        <span></span>
        <span></span>
      </div>
        <div *ngIf="profileDetails" class="top_header_ryt">
          <div class="outlet-select" *ngIf="outlets.length">
            <mat-form-field appearance="outline" class="outlet-select__field">
              <mat-select
                [value]="selectedOutletId"
                (selectionChange)="onOutletChange($event.value)">
                <mat-option
                  *ngFor="let outlet of outlets"
                  [value]="outlet._id">
                  {{ outlet.outletName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        <!-- Inventory Alert Icon -->
        <button mat-icon-button
          [matMenuTriggerFor]="inventoryMenu"
          matBadgeColor="warn"
          matBadgeOverlap="false"
          class="inventory-alert-btn">
          <i class="fa fa-box"></i>
        </button>

        <mat-menu
          #inventoryMenu="matMenu"
          xPosition="before"
          yPosition="below"
          class="noti_dropBox">
          <div class="d_flx">
            <h2>{{ 'LowStockAlerts' | translate }}</h2>
            <button
              class="see_link"
              routerLink="/low-stocks"
              type="button">
              {{ 'SeeAll' | translate }}
            </button>
          </div>

          <ul class="not_list" *ngIf="lowStockItems.length > 0; else noAlerts">
            <li class="ntf-list" *ngFor="let item of lowStockItems">
              <div class="ntf_dt">
                <h3>{{item.productName}}</h3>
                <p class="vendor-name">{{item.vendorName}}</p>
                <p class="stock-info">
                  <span class="quantity" [class.critical]="item.availableQuantity <= 0">
                    {{ 'Quantity' | translate }}: {{item.availableQuantity}}
                  </span>
                  <span class="threshold">{{ 'Threshold' | translate }}: {{item.threshold}}</span>
                </p>
              </div>
            </li>
          </ul>
          <ng-template #noAlerts>
            <div class="no-alerts">
              <p>{{ 'NoLowStockAlerts' | translate }}</p>
            </div>
          </ng-template>
        </mat-menu>
        <mat-slide-toggle
          [checked]="profileDetails.isAvailable"
          (change)="onToggleChanged($event)"
          >{{
            (profileDetails.isAvailable ? 'Online' : 'Offline') | translate
          }}</mat-slide-toggle
        >

        <!-- Language Switcher -->
        <div class="lang_switch" mat-button [matMenuTriggerFor]="languageMenu">
          <i class="fa fa-globe" aria-hidden="true"></i>
          <span class="lang_code">{{ currentLanguage | uppercase }}</span>
        </div>

        <mat-menu #languageMenu="matMenu" yPosition="below" class="dropdown dropbox">
          <ul class="hd_menu">
            <li
              *ngFor="let language of languages"
              [class.active]="language.code === currentLanguage"
              (click)="changeLanguage(language.code)">
              {{ language.label }}
            </li>
          </ul>
        </mat-menu>

        <figure mat-button [matMenuTriggerFor]="belowMenu">
          <img
            [src]="
              profileDetails && profileDetails.image
                ? profileDetails.image
                : assetsConst.profileLogo
            "
            alt="profile" />
        </figure>

        <mat-menu
          #belowMenu="matMenu"
          yPosition="below"
          class="dropdown dropbox">
          <ul class="hd_menu">
            <li routerLink="/profile/view-profile">
              <figure>
                <img [src]="assetsConst.userLogo" alt="profile" />
              </figure>
              {{ 'MyProfile' | translate }}
            </li>
            <li routerLink="/password/change-paswd">
              <figure>
                <img [src]="assetsConst.passwordLogo" alt="profile" />
              </figure>
              {{ 'ChangePassword' | translate }}
            </li>
            <li (click)="logout()">
              <figure>
                <img [src]="assetsConst.logoutLogo" alt="profile" />
              </figure>
              {{ 'Logout' | translate }}
            </li>
          </ul>
        </mat-menu>
      </div>
    </div>
    <main class="main_wrapper">
      <router-outlet></router-outlet>
    </main>
    <mat-menu #menu="matMenu"> </mat-menu>
  </div>
</mat-sidenav-container>
